exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Background image */\n#bg {\n  position: fixed; \n  top: 0; \n  left: 0; \n\t\n  /* Preserve aspet ratio */\n  min-width: 90%;\n  min-height: 99%;\n}\n\n/*.login {\n  background: rgba(255,255,255, 0.8);\n}*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/user/login/login.component.css
// module id = ../../../../../src/app/user/login/login.component.css
// module chunks = main